import {NoteObject} from "./objects/NoteObject";
import {DBModel} from "./database/IndexedDB";
import NoteFolder from "./objects/NoteFolder";

declare global {
    interface Window {
        historyBack: () => void
        historyForward: () => void
        CdvPurchase: any
        cordova: any
    }
}

export type AppLanguage = {
    code: string
    displayName: {
        [lang: string]: string
    }
}

export type PanEvent = {
    type: 'Pan',
    movement: Point
}

export type RequestCenterEvent = {
    type: 'RequestCenter',
}

export type CancelAllActionsEvent = {
    type: 'CancelAllActions'
}

export type AddToHistoryEvent = {
    type: 'AddToHistory'
}

export type HistoryChangedEvent = {
    type: 'HistoryChanged'
}

export type HeaderMenuOpenEvent = {
    type: 'HeaderMenuOpen'
    id: string
}

export enum BackgroundType {
    NONE = 'none',
    LINES1 = 'lines1',
    LINES2 = 'lines2',
    SQUARES1 = 'squares1',
    SQUARES2 = 'squares2',
}

export type NotePathPoint = {
    x: number
    y: number
    defaultLineWidth: number
    lineWidth: number
}

export type Transform = {
    x: number
    y: number
    scale: number
}

export type Point = {
    x: number
    y: number
}

export type Box = {
    x: number
    y: number
    width: number
    height: number
}

export type HistoryPointerList = {
    [ noteId: string ]: number
}

export type HistoryStatus = {
    length: number
    pointer: number
    hasPrevious: boolean
    hasNext: boolean
}

export interface NoteSearchOptions {
    deleted?: boolean
    folderId?: string
}

export type DBChangeEventAction = 'create' | 'update' | 'delete'

export type DBChangeEvent = {
    table: string
    action: DBChangeEventAction
    object: DBModel
}

export interface DBChangeListener {
    tables: string[] | null
    actions: DBChangeEventAction[] | null
    onChange: (event: DBChangeEvent) => void
}

export interface Database {
    initialized: boolean
    createNewNote: (data?: { folderId?: string }) => Promise<NoteObject>
    getNote: (noteId: string) => Promise<NoteObject>
    getNotes: (where?: NoteSearchOptions) => Promise<NoteObject[]>
    deleteNote: (noteId: string) => Promise<void>
    deleteNotes: (noteIds: string[], permanent?: boolean) => Promise<void>

    addEventListener(tables: string[] | string | null, actions: DBChangeEventAction[] | null, onChange: (event: DBChangeEvent) => void): void
    removeEventListener(onChange: (event: DBChangeEvent) => void): void

    updateNote: (note: NoteObject, keepTimestamp?: boolean) => Promise<void>
    notes: NoteObject[]

    setEncryptionPassword: (password: string|null) => void

    getFolder: (id: string) => Promise<NoteFolder>
    getFolders: (parentId?: string | null) => Promise<NoteFolder[]>
    getFoldersRecursive: (parentId?: string | null) => Promise<NoteFolder[]>
    createFolder: (title: string, parentId?: string | null) => Promise<void>
    updateFolder: (folder: NoteFolder) => Promise<void>

    createHistorySnapshot: (noteId: string) => void
    noteHistory: NoteObject[]
    historyStatusForNote: (noteId: string) => HistoryStatus
    historyGoBack: (noteId: string) => void
    historyGoForward: (noteId: string) => void
}